import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.onchange = this.change.bind(this);
  }

  change(event) {
    const selectedValue = event.target.value;
    const url = new URL(window.location);

    // Update or add the page_status parameter
    if (selectedValue) {
      url.searchParams.set("page_status", selectedValue);
    } else {
      url.searchParams.delete("page_status");
    }

    // Navigate to the updated URL
    window.location.href = url.toString();
  }
}
